<template>
  <span class="c-spinner">
    <span
      :class="{ 'c-spinner__item--white': white }"
      class="c-spinner__item"
    />
  </span>
</template>
<script>
export default {
  name: 'Spinner',
  props: {
    white: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.c-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &--inline {
    width: auto;
  }

  &.cover-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    transform: translate(-50%, -50%);
  }
}

.c-spinner__item {
  display: block;
  width: 1.5em !important;
  height: 1.5em !important;
  border-radius: 50%;
  margin: auto;
  background-color: transparent;
  border: 3px solid transparent;
  border-top: 3px solid var(--color-black);
  border-right: 3px solid var(--color-black);
  transition: 0.2s;
  animation: loading 600ms linear infinite;

  .c-spinner--slider & {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -0.75em;
    margin-left: -0.75em;
  }

  &--white {
    border-top-color: white;
    border-right-color: white;
  }
}

@keyframes loading {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
